import { isOfflineSignature, SignatureOrOffline } from './common';
import helpers from '../helpers/helpers';

export default {
  basicSignatureFields: (signature: SignatureOrOffline, username: String, female: boolean = false) => [
    { key: `Validé${female ? 'e' : ''} le`, value: helpers.dateTimeFormat(signature.date) },
    { key: 'Par', value: isOfflineSignature(signature) ? username : signature.userName },
  ],
};
